import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import CreateCategory from "@/features/product-categories/create-product-category/create-category-modal";
import CategoriesTable from "@/features/product-categories/product-categories-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/products/categories/",
)({
  beforeLoad: ({ context }) => {
    const canReadProductCategories = context.ability.can(
      "read",
      "ProductCategory",
    );

    if (!canReadProductCategories) {
      console.error("User does not have permission to read product categories");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: CategoriesPage,
});

function CategoriesPage() {
  const { museumId } = Route.useParams();
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Kategorier</Trans>
        </h1>

        <Can I="create" a="ProductCategory">
          <CreateCategory />
        </Can>
      </Flex>

      <CategoriesTable museumId={museumId} />
    </Box>
  );
}
